var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { margin: "1.5em" } },
    [
      _c(
        "sui-card",
        { staticClass: "centered activate-acct-card" },
        [
          _c(
            "sui-card-content",
            [
              _c(
                "div",
                {
                  staticClass: "center aligned header",
                  staticStyle: { margin: "2em" },
                },
                [_vm._v("Activate your account.")]
              ),
              _vm.isAccountActivated === false
                ? _c(
                    "sui-message",
                    { staticClass: "activate-account-message" },
                    [_vm._v(" Please set the password for your account. ")]
                  )
                : _vm._e(),
              _vm.isAccountActivated
                ? _c(
                    "sui-message",
                    { staticClass: "account-activated-message" },
                    [_vm._v(" Your account was activated successfully! ")]
                  )
                : _vm._e(),
              [
                _vm.isAccountActivated === false
                  ? _c(
                      "sui-form",
                      { staticClass: "activate-account-form" },
                      [
                        _c(
                          "sui-form-field",
                          [
                            _c("label", [_vm._v("New Password")]),
                            _c("sui-input", {
                              attrs: {
                                type: "password",
                                placeholder: "Enter new password",
                                autocomplete: "off",
                              },
                              model: {
                                value: _vm.password,
                                callback: function ($$v) {
                                  _vm.password = $$v
                                },
                                expression: "password",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("label", [_vm._v("Confirm New Password")]),
                            _c("sui-input", {
                              attrs: {
                                type: "password",
                                placeholder: "Confirm new password",
                                autocomplete: "off",
                              },
                              model: {
                                value: _vm.passwordConfirmation,
                                callback: function ($$v) {
                                  _vm.passwordConfirmation = $$v
                                },
                                expression: "passwordConfirmation",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.isAccountActivated === false
                          ? _c("sui-button", {
                              attrs: {
                                content: "Activate Account",
                                type: "button",
                                fluid: "",
                                color: "teal",
                              },
                              on: { click: _vm.submit },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              _c("sui-divider", { attrs: { hidden: "" } }),
              _vm.isAccountActivated
                ? _c(
                    "div",
                    { staticClass: "login" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "login-link",
                          attrs: { to: "/account/login" },
                        },
                        [_vm._v(" Log In ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm.$store.getters.isRequesting ? _c("Loader") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }